export function setErrors(error) {
    const errors = error.responseJSON.errors;

    for (const error in errors) {
        const errorMessage = document.querySelector(`[data-key="${error}"]`);
        errorMessage.innerHTML = '';
        errorMessage.innerHTML = `${errors[error]}`;
    }
}
